import React from 'react';
import { ICCSocialMedia } from '../../interfaces/social-media.interface';

interface IProps {
    account: ICCSocialMedia;
    selectedAccounts: ICCSocialMedia[];
    setSelectedAccounts: React.Dispatch<React.SetStateAction<ICCSocialMedia[]>>;
}

const PublishSocialAccount = ({ account, selectedAccounts, setSelectedAccounts }: IProps) => {
    const isSelected = selectedAccounts.findIndex((sAccount) => sAccount.id === account.id) !== -1;

    const handleClick = () => {
        setSelectedAccounts((prevAccounts) => {
            if (isSelected) {
                const index = selectedAccounts.findIndex((sAccount) => sAccount.id === account.id);
                const newAccounts = [...prevAccounts];
                newAccounts.splice(index, 1);
                return newAccounts;
            } else {
                const newAccounts = [...prevAccounts, account];
                return newAccounts;
            }
        });
    };

    return (
        <div
            className={`tw-w-full tw-rounded-md tw-p-2 tw-flex tw-items-center tw-gap-x-3 tw-cursor-pointer tw-border-2 ${!isSelected ? 'tw-border-gray-250' : 'tw-border-purple-500 tw-bg-purple-500'}`}
            onClick={handleClick}
        >
            <div className="tw-rounded-full tw-w-8 tw-h-8 tw-bg-gray-250">
                {account.profilePicUrl && account.profilePicUrl.length > 0 && (
                    <img className="tw-rounded-full" src={account.profilePicUrl} />
                )}
            </div>
            <div className={`tw-text-sm ${isSelected ? 'tw-text-white' : 'tw-text-[#09090B]'}`}>
                {account.platformType}
            </div>
        </div>
    );
};

export default PublishSocialAccount;
